import { render, staticRenderFns } from "./auction_deal_detail.vue?vue&type=template&id=245a0c1b&scoped=true"
import script from "./auction_deal_detail.vue?vue&type=script&lang=js"
export * from "./auction_deal_detail.vue?vue&type=script&lang=js"
import style0 from "./auction_deal_detail.vue?vue&type=style&index=0&id=245a0c1b&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245a0c1b",
  null
  
)

export default component.exports